// Small helpers shared by every grammar topic.
export const pick = <T,>(a: T[]): T => a[Math.floor(Math.random() * a.length)];

export function shuffle<T>(a: T[]): T[] {
  const b = [...a];
  for (let i = b.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [b[i], b[j]] = [b[j], b[i]];
  }
  return b;
}

/** Up to `n` distinct wrong options (never the answer), shuffled in with it. */
export function options(answer: string, wrong: string[], n = 3): string[] {
  const w = [...new Set(wrong.filter(x => x && x !== answer))];
  return shuffle([answer, ...shuffle(w).slice(0, n)]);
}
